(function () {
  let session = null;

  const disconnect = () => {
    if (!session) return;
    session.token += 1;
    session.openBtn.removeEventListener("click", session.open);
    session.closeBtn.removeEventListener("click", session.close);
    document.removeEventListener("keydown", session.onKeydown);
    session.menu.classList.remove("aside-menu--open");
    delete session.menu.dataset.asideReady;
    document.body.classList.remove("overflow-hidden-drawer");
    if (session.header) session.header.preventHide = false;
    session = null;
  };

  const initAsideMenu = () => {
    disconnect();

    const header = document.querySelector(".header-wrapper");
    const asideMenu = document.querySelector(".aside-menu");
    const openBtn = document.querySelector(".aside-menu__toggle--open-btn");
    const closeBtn = document.querySelector(".aside-menu__toggle--close-btn");
    const container = document.querySelector(".aside-menu__container");
    if (!asideMenu || !openBtn || !closeBtn || !container) return;

    asideMenu.style.setProperty("--top-height", `${container.getBoundingClientRect().top}px`);
    if (header) header.preventHide = false;

    const focusableSelector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "summary",
      "[tabindex]:not([tabindex='-1'])",
    ].join(",");

    const isAvailable = (element) => {
      if (element.hasAttribute("disabled") || element.getAttribute("aria-hidden") === "true") return false;
      if (element.closest("[hidden]")) return false;
      let node = element.parentElement;
      while (node && node !== asideMenu) {
        if (node.tagName === "DETAILS" && !node.open) {
          let summary = null;
          for (const child of node.children) {
            if (child.tagName === "SUMMARY") {
              summary = child;
              break;
            }
          }
          if (!summary || !summary.contains(element)) return false;
        }
        node = node.parentElement;
      }
      return true;
    };

    const focusableItems = () => Array.from(asideMenu.querySelectorAll(focusableSelector)).filter(isAvailable);

    const current = {
      token: 0,
      menu: asideMenu,
      header,
      openBtn,
      closeBtn,
      returnFocus: null,
    };
    session = current;

    const moveFocusInside = () => {
      const items = focusableItems();
      const target = items[0] || asideMenu.querySelector(".aside-menu__wrapper");
      if (target) target.focus();
    };

    const dialogIsVisible = () => typeof getComputedStyle !== "function" || getComputedStyle(asideMenu).visibility !== "hidden";

    const moveFocusWhenVisible = (token, remaining = 90) => {
      if (session !== current || token !== current.token || !asideMenu.classList.contains("aside-menu--open")) return;
      if (dialogIsVisible() || remaining === 0) {
        moveFocusInside();
        return;
      }
      requestAnimationFrame(() => moveFocusWhenVisible(token, remaining - 1));
    };

    const open = (event) => {
      event.preventDefault();
      current.returnFocus = event.currentTarget || document.activeElement;
      if (header) header.preventHide = true;
      asideMenu.classList.add("aside-menu--open");
      document.body.classList.add("overflow-hidden-drawer");
      current.token += 1;
      moveFocusWhenVisible(current.token);
    };

    const close = (event) => {
      if (event) event.preventDefault();
      current.token += 1;
      asideMenu.classList.remove("aside-menu--open");
      document.body.classList.remove("overflow-hidden-drawer");
      if (header) header.preventHide = false;
      const target = current.returnFocus;
      current.returnFocus = null;
      if (target && !asideMenu.contains(target)) target.focus();
    };

    const keepFocusInside = (event) => {
      if (event.key !== "Tab" || !asideMenu.classList.contains("aside-menu--open")) return;
      const items = focusableItems();
      if (!items.length) {
        event.preventDefault();
        return;
      }
      const index = items.indexOf(document.activeElement);
      if (index === -1 || (event.shiftKey && index === 0) || (!event.shiftKey && index === items.length - 1)) {
        event.preventDefault();
        items[event.shiftKey ? items.length - 1 : 0].focus();
      }
    };

    const onKeydown = (event) => {
      if (session !== current || !asideMenu.classList.contains("aside-menu--open")) return;
      if (event.code === "Escape") {
        close(event);
        return;
      }
      keepFocusInside(event);
    };

    current.open = open;
    current.close = close;
    current.onKeydown = onKeydown;
    openBtn.addEventListener("click", open);
    closeBtn.addEventListener("click", close);
    document.addEventListener("keydown", onKeydown);
    asideMenu.dataset.asideReady = "true";
  };

  const sectionHasMenu = (event) => {
    const section = event && event.target;
    return !!(section && section.querySelector && (section.querySelector(".aside-menu") || section.querySelector(".aside-menu__toggle--open-btn")));
  };

  document.addEventListener("shopify:section:load", (event) => {
    if (event && event.target && !sectionHasMenu(event) && session && session.menu.isConnected !== false) return;
    initAsideMenu();
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (!session) return;
    const section = event && event.target;
    if (section && section.contains && (section.contains(session.menu) || section.contains(session.openBtn))) disconnect();
  });

  document.addEventListener("shopify:section:reorder", (event) => {
    if (event && event.target && !sectionHasMenu(event) && session && session.menu.isConnected !== false) return;
    initAsideMenu();
  });

  initAsideMenu();
})();
